if (!customElements.get('fp-sensor')) {
  customElements.define('fp-sensor', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.querySelectorAll('[data-shipping-trigger]').forEach((trigger) => {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', this.dataset.shippingOverlay);
      });
      this.addEventListener('click', (event) => {
        const trigger = event.target instanceof Element && event.target.closest('[data-shipping-trigger]');
        if (trigger) this.openShipping(trigger, event);
      }, { signal: this.abort.signal });
      this.addEventListener('keydown', (event) => {
        const trigger = event.target instanceof Element && event.target.closest('[data-shipping-trigger]');
        if (trigger && event.key === ' ') this.openShipping(trigger, event);
      }, { signal: this.abort.signal });
      const button = this.querySelector('[data-copy-code]');
      if (!button) return;
      button.hidden = false;
      button.addEventListener('click', async () => {
        const code = this.querySelector('[data-coupon-code]').textContent.trim();
        const status = this.querySelector('[data-copy-status]');
        const fallback = this.querySelector('.fp-sensor__manual-copy');
        button.disabled = true;
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(code);
          fallback.hidden = true;
          status.textContent = button.dataset.success;
        } catch {
          fallback.hidden = false;
          const input = fallback.querySelector('input');
          input.focus();
          input.select();
          status.textContent = button.dataset.failure;
        } finally {
          button.disabled = false;
        }
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() {
      this.closeShipping();
      this.abort?.abort();
    }
    openShipping(trigger, event) {
      const source = document.getElementById(trigger.dataset.shippingTrigger);
      if (!(source instanceof HTMLTemplateElement) || !source.content.firstElementChild) return;
      event.preventDefault();
      this.closeShipping();
      this.shippingAbort = new AbortController();
      const overlay = document.createElement('div');
      overlay.id = this.dataset.shippingOverlay;
      overlay.className = 'fp-sensor-shipping-overlay';
      overlay.append(source.content.firstElementChild.cloneNode(true));
      this.shippingOverlay = overlay;
      this.shippingOpener = trigger;
      this.previousOverflow = document.body.style.overflow;
      document.body.append(overlay);
      document.body.style.overflow = 'hidden';
      this.inertSiblings = Array.from(document.body.children).filter((element) => {
        return element !== overlay && !element.inert && !['SCRIPT', 'STYLE'].includes(element.tagName);
      });
      this.inertSiblings.forEach((element) => { element.inert = true; });
      overlay.addEventListener('click', (clickEvent) => {
        if (clickEvent.target === overlay || clickEvent.target.closest('#fp-vg-close')) this.closeShipping();
      }, { signal: this.shippingAbort.signal });
      document.addEventListener('keydown', (keyEvent) => {
        if (keyEvent.key === 'Escape') {
          keyEvent.preventDefault();
          this.closeShipping();
        } else if (keyEvent.key === 'Tab') {
          const items = Array.from(overlay.querySelectorAll('button, a[href], input, select, textarea, [tabindex="0"]'))
            .filter((element) => !element.disabled && element.getClientRects().length);
          const first = items[0];
          const last = items[items.length - 1];
          if (!first) return;
          if (keyEvent.shiftKey && (document.activeElement === first || !overlay.contains(document.activeElement))) {
            keyEvent.preventDefault();
            last.focus();
          } else if (!keyEvent.shiftKey && (document.activeElement === last || !overlay.contains(document.activeElement))) {
            keyEvent.preventDefault();
            first.focus();
          }
        }
      }, { signal: this.shippingAbort.signal });
      overlay.querySelector('#fp-vg-close')?.focus({ preventScroll: true });
    }
    closeShipping() {
      if (!this.shippingOverlay) return;
      this.shippingAbort?.abort();
      this.shippingOverlay.remove();
      this.shippingOverlay = null;
      document.body.style.overflow = this.previousOverflow;
      this.inertSiblings.forEach((element) => { element.inert = false; });
      this.inertSiblings = [];
      const opener = this.shippingOpener;
      this.shippingOpener = null;
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    }
  });
}

